import { createAction, handleActions } from "redux-actions";
import * as R from "ramda";
import { ExportIcon } from "../icons/icons";

export const types = {
  getCustomers: "CUSTOMERS_GET_CUSTOMERS",
  getCustomer: "CUSTOMERS_GET_CUSTOMER",
  createCustomer: "CUSTOMER_CREATE_CUSTOMER",
  setCustomer: "CUSTOMER_SET_CUSTOMER",
  deleteCustomer: "CUSTOMER_DELETE_CUSTOMER",
  getCustomersDone: "CUSTOMERS_GET_CUSTOMERS_DONE",
  getCustomerDone: "CUSTOMERS_GET_CUSTOMER_DONE",
  createCustomerDone: "CUSTOMER_CREATE_CUSTOMER_DONE",
  setCustomerDone: "CUSTOMERS_SET_CUSTOMER_DONE",
  deleteCustomerDone: "CUSTOMER_DELETE_CUSTOMER_DONE",
  requestingCustomers: "CUSTOMER_REQUEST_CUSTOMERS",
  setCustomersFilter: "CUSTOMER_SET_FILTER",
  setCustomerPhoto: "CUSTOMER_SET_PHOTO",
  setCustomerPhotoDone: "CUSTOMER_SET_PHOTO_DONE",
  setCustomerGallery: "CUSTOMER_SET_GALLERY",
  setCustomerGalleryDone: "CUSTOMER_SET_GALLERY_DONE",
  papGetAuditRecords: "CUSTOMER_GET_AUDIT_RECORDS",
  papGetAuditRecordsSuccess: "CUSTOMER_GET_AUDIT_RECORDS_SUCCESS",
  papCloseAuditModal: "CUSTOMER_CLOSE_AUDIT_MODAL",
  papSetCurrentPapAuditRecord: "CUSTOMER_SET_CURRENT_PAP_AUDIT_RECORD",
  setCustomerGalleryTag: "CUSTOMER_SET_GALLERY_TAG",
  setCustomerGalleryTagDone: "CUSTOMER_SET_GALLERY_TAG_DONE",
  deleteCustomerGallery: "CUSTOMER_DELETE_GALLERY",
  deleteCustomerGalleryDone: "CUSTOMER_DELETE_GALLERY_DONE",
  setCustomerError: "CUSTOMER_SET_CUSTOMER_ERROR",
  navigateToCustomer: "CUSTOMER_NAVIGATETO_CUSTOMER",
  navigateToCustomerDone: "CUSTOMER_NAVIGATETO_CUSTOMER_DONE",

  // Testing dropdown
  customerHandleForm: "CUSTOMER_HANDLE_FORM",
  setCustomerValues: "SET_CUSTOMER_VALUES",
  bowlerScreenClick: "BOWLER_SCREEN_CLICK",
  bowlerSetOpenDropdownBowler: "BOWLER_SET_OPEN_DROPDOWN_BOWLER",
  bowlerScreenClickOpen: "BOWLER_SCREEN_CLICK_OPEN",
  bowlerSetActiveTabKey: "BOWLER_SET_ACTIVE_TAB_KEY",
  //end Testing dropdown
  customerPrint: "CUSTOMER_PRINT",
  customerPrinted: "CUSTOMER_PRINTED",
  updateBall: "CUSTOMER_UPDATE_BALL",
  divPrint: "DIV_PRINT",
  divPrinted: "DIV_PRINTED",
  exportCustomers: "EXPORT_CUSTOMERS",
  exportCustomersDone: "EXPORT_CUSTOMERS_DONE",
};

export const getCustomers = createAction(types.getCustomers);
export const getCustomer = createAction(types.getCustomer);
export const createCustomer = createAction(types.createCustomer);
export const setCustomer = createAction(types.setCustomer);
export const deleteCustomer = createAction(types.deleteCustomer);
export const requestingCustomers = createAction(types.requestingCustomers);
export const getCustomersDone = createAction(types.getCustomersDone);
export const getCustomerDone = createAction(types.getCustomerDone);
export const createCustomerDone = createAction(types.createCustomerDone);
export const setCustomerDone = createAction(types.setCustomerDone);
export const deleteCustomerDone = createAction(types.deleteCustomerDone);
export const setCustomersFilter = createAction(types.setCustomersFilter);
export const setCustomerPhoto = createAction(types.setCustomerPhoto);
export const setCustomerPhotoDone = createAction(types.setCustomerPhotoDone);
export const setCustomerGallery = createAction(types.setCustomerGallery);
export const setCustomerGalleryDone = createAction(
  types.setCustomerGalleryDone
);
export const papGetAuditRecords = createAction(types.papGetAuditRecords);
export const papGetAuditRecordsSuccess = createAction(
  types.papGetAuditRecordsSuccess
);
export const papCloseAuditModal = createAction(types.papCloseAuditModal);
export const papSetCurrentPapAuditRecord = createAction(
  types.papSetCurrentPapAuditRecord
);
export const setCustomerGalleryTag = createAction(
  types.setCustomerGalleryTag
);
export const setCustomerGalleryTagDone = createAction(
  types.setCustomerGalleryTagDone
);
export const deleteCustomerGallery = createAction(
  types.deleteCustomerGallery
);
export const deleteCustomerGalleryDone = createAction(
  types.deleteCustomerGalleryDone
);
export const setCustomerError = createAction(types.setCustomerError);
export const navigateToCustomer = createAction(types.navigateToCustomer);
export const navigateToCustomerDone = createAction(
  types.navigateToCustomerDone
);
// Testing dropdown
export const customerHandleForm = createAction(types.customerHandleForm);
export const setCustomerValues = createAction(types.setCustomerValues);
export const bowlerScreenClick = createAction(types.bowlerScreenClick);
export const bowlerSetOpenDropdownBowler = createAction(
  types.bowlerSetOpenDropdownBowler
);
export const bowlerSetActiveTabKey = createAction(types.bowlerSetActiveTabKey);
export const bowlerScreenClickOpen = createAction(types.bowlerScreenClickOpen);
// end testing dropdown
export const customerPrint = createAction(types.customerPrint);
export const customerPrinted = createAction(types.customerPrinted);
export const divPrint = createAction(types.divPrint);
export const divPrinted = createAction(types.divPrinted);
export const updateBall = createAction(types.updateBall);

export const exportCustomers = createAction(types.exportCustomers);
export const exportCustomersDone = createAction(types.exportCustomersDone);

export const INITIAL_STATE = {
  customers: [],
  offset: 0,
  limit: 100,
  hasMore: true,
  orderBy: "lastname, firstname",
  filter: "",
  loadingCustomers: false,
  selectedCustomer: null,
  loadingCustomer: false,
  deletingCustomer: false,
  creatingCustomer: false,
  error: "",
  navigateToCustomer: null,
  // Testing dropdown
  openDropdownBowler: "",
  tabChange: false,
  activeTabKey: "1",
  updatingCustomerValues: false,
  savingPhoto: false,
  // end testing dropdown
  savingGallery: false,
  customerError: false,
};

// Testing dropdown
const selectedCustomer = [
  "id",
  "firstname",
  "lastname",
  "email",
  "password",
  "telephone",
  "hand",
  "style",
  "address",
  "country",
  "state",
  "city",
  "postal_code",
  "preferred_lang",
  "photo",
  "pap_h",
  "pap_v",
  "axis_rot",
  "axis_tilt",
  "ball_speed",
  "rev_rate",
  "papAuditRecords",
  "currentPapAuditRecord",
  "currentPapAuditRecordIdx",
  "gettingAuditRecords",
  "showAuditModal",
  "gallery",
];

const activeTabKeyChecker = (openDropdownBowler) => {
  const tabKeyFields = {
    1: R.indexOf(R.__, selectedCustomer),
  };

  return R.pipe(
    R.mapObjIndexed((indexFn, key) =>
      indexFn(openDropdownBowler) >= 0 ? key : ""
    ),
    R.values(),
    R.filter((val) => val !== ""),
    (keys) => keys[0]
  )(tabKeyFields);
};
//end testing dropdown

export const bowlersReducer = handleActions(
  {
    [types.getCustomers]: (state, action) => {
      return {
        ...state,
        customers: action.payload.loadMore
          ? state.customers
          : action.payload.offset === 0 || R.isNil(action.payload.offset)
          ? []
          : state.customers,
        limit: !R.isNil(action.payload.limit)
          ? action.payload.limit
          : state.limit,
        offset: !R.isNil(action.payload.offset)
          ? action.payload.offset
          : state.offset,
        orderBy: !R.isNil(action.payload.orderBy)
          ? action.payload.orderBy
          : state.orderBy,
        hasMore: action.payload.loadMore ? state.hasMore : true,
        loadingCustomers: true,
      };
    },
    [types.getCustomersDone]: (state, action) => ({
      ...state,
      offset: state.customers.length + action.payload.customers.length,
      customers: [...state.customers, ...action.payload.customers],
      hasMore: action.payload.customers.length >= state.limit,
      loadingCustomers: false,
    }),
    [types.getCustomer]: (state) => ({
      ...state,
      loadingCustomer: true,
    }),
    [types.getCustomerDone]: (state, action) => ({
      ...state,
      selectedCustomer: action.payload.customer,
      loadingCustomer: false,
    }),
    [types.setCustomersFilter]: (state, action) => ({
      ...state,
      filter: action.payload.filter,
    }),
    [types.setCustomerPhoto]: (state) => ({
      ...state,
      savingPhoto: true,
    }),
    [types.setCustomerPhotoDone]: (state, action) => ({
      ...state,
      savingPhoto: false,
      selectedCustomer: {
        ...state.selectedCustomer,
        photo: action.payload.photo,
      },
    }),
    [types.setCustomer]: (state) => ({
      ...state,
      updatingCustomerValues: true,
    }),
    [types.setCustomerDone]: (state, action) => ({
      ...state,
      savingPhoto: false,
      savingGallery: false,
      updatingCustomerValues: false,
      customerError: false,
      selectedCustomer: {
        ...state.selectedCustomer,
        ...action.payload.bowler,
      },
    }),
    "WRITE_SPECTRE_POS_LINK_DONE": (state, action) => {
      const sc = state.selectedCustomer;
      const wcId = parseInt(action.payload?.wcCustomerId, 10);
      const sid = action.payload?.spectreCustomerId;
      // A shop on HBS: the server already wrote the link and hands it back
      // whole (its customer id is not a number).
      const hbsLink = action.payload?.posLink;
      if (sc && hbsLink && sc.id === sid) {
        let current = {};
        try {
          current =
            typeof sc.extra_values === "string"
              ? JSON.parse(sc.extra_values) || {}
              : sc.extra_values || {};
        } catch (e) {
          current = {};
        }
        return {
          ...state,
          selectedCustomer: {
            ...sc,
            extra_values: JSON.stringify({ ...current, pos: hbsLink }),
          },
        };
      }
      if (!sc || !wcId || sc.id !== sid) return state;

      let parsed = {};
      const raw = sc.extra_values;
      if (raw) {
        try {
          parsed = typeof raw === "string" ? JSON.parse(raw) || {} : raw;
        } catch (e) {
          parsed = {};
        }
      }
      parsed.pos = {
        ...(parsed.pos || {}),
        customer_id: wcId,
        linked_at: parsed?.pos?.linked_at || new Date().toISOString(),
        source: parsed?.pos?.source || "v3",
      };
      return {
        ...state,
        selectedCustomer: {
          ...sc,
          extra_values: JSON.stringify(parsed),
        },
      };
    },
    [types.papGetAuditRecords]: (state) => ({
          ...state,
          selectedCustomer:{
            ...state.selectedCustomer,
          gettingAuditRecords: true,
          showAuditModal: true,
          currentPapAuditRecordIdx: -1,
          currentPapAuditRecord: null,
          }
        }),
    [types.papGetAuditRecordsSuccess]: (state, action) => ({
      ...state,
      selectedCustomer: {
        ...state.selectedCustomer,
        gettingAuditRecords: false,
        papAuditRecords: action.payload.papAuditRecords,
        currentPapAuditRecordIdx: action.payload.papAuditRecords.length -1,
        currentPapAuditRecord: action.payload.papAuditRecords[
          action.payload.papAuditRecords.length - 1
        ],
        showAuditModal: true,
      },
    }),
    [types.papCloseAuditModal]: (state) => ({
          ...state,
          selectedCustomer: {
            ...state.selectedCustomer,
          showAuditModal: false,
          currentPapAuditRecord: null,
          currentPapAuditRecordIdx: -1,
          }
        }),
    [types.papSetCurrentPapAuditRecord]: (state, action) => ({
          ...state,
          selectedCustomer: {
            ...state.selectedCustomer,
          currentPapAuditRecordIdx:
            action.payload.currentPapAuditRecordIdx,
          currentPapAuditRecord:
            state.specsheetAuditRecords[
              action.payload.currentPapAuditRecordIdx
            ],
          }
        }),
    [types.setCustomerGallery]: (state) => ({
      ...state,
      savingGallery: true,
      customerError: false,
    }),
    [types.setCustomerGalleryTag]: (state) => ({
      ...state,
      savingGallery: true,
      customerError: false,
    }),
    [types.setCustomerGalleryTagDone]: (state, action) => ({
      ...state,
      savingGallery: false,
      selectedCustomer: {
        ...state.selectedCustomer,
        gallery: state.selectedCustomer.gallery.map((item) =>
          item.file === action.payload.fileName
            ? {
                ...item,
                tag: action.payload.tag,
              }
            : item
        ),
      },
    }),
        [types.setCustomerGalleryDone]: (state, action) => ({
            ...state,
            savingGallery: false,
            selectedCustomer: {
                ...state.selectedCustomer,
                gallery: [...state.selectedCustomer.gallery, ...action.payload.gallery],
            }
          }),
    [types.deleteCustomerGalleryDone]: (state, action) => {
          {const  fileName  = action.payload.fileName;
          return {
            ...state,
            selectedCustomer: {
              ...state.selectedCustomer,
              gallery: state.selectedCustomer.gallery.filter((item) => item !== fileName), 
            },
          };
          };
        },
    [types.setCustomerError]: (state, action) => ({
      ...state,
      error: action.payload.error,
      customerError: true,
      loadingCustomer: false,
      savingGallery: false,
      savingPhoto: false,
      updatingCustomerValues: false,
    }),
    [types.navigateToCustomer]: (state, action) => ({
      ...state,
      navigateToCustomer: action.payload.navigateTo,
    }),
    [types.navigateToCustomerDone]: (state) => ({
      ...state,
      navigateToCustomer: null,
    }),
    // Testing dropdown
    [types.customerHandleForm]: (state) => ({
      ...state,
      updatingCustomerValues: true,
    }),
    [types.setCustomerValues]: (state, action) => ({
      ...state,
      selectedCustomer: action.payload.selectedCustomer,
      openDropdownBowler: "",
      updatingCustomerValues: false,
    }),
    [types.bowlerScreenClick]: (state, action) => ({
      ...state,
      activeTabKey: activeTabKeyChecker(action.payload.openDropdownBowler),
      tabChange:
        activeTabKeyChecker(action.payload.openDropdownBowler) !==
        state.activeTabKey,
    }),
    [types.bowlerSetOpenDropdownBowler]: (state, action) => ({
      ...state,
      openDropdownBowler: action.payload.openDropdownBowler,
    }),
    [types.bowlerScreenClickOpen]: (state) => ({
      ...state,
      openDropdownBowler: "",
      tabChange: false,
    }),
    [types.bowlerSetActiveTabKey]: (state, action) => ({
      ...state,
      activeTabKey: action.payload.activeTabKey,
      tabChange: false,
    }),
    [types.updateBall]: (state, action) => {
      const ballIndex = R.findIndex(R.propEq("id", action.payload.ball.id))(
        state.selectedCustomer.balls_drilled
      );

      return {
        ...state,
        selectedCustomer: {
          ...state.selectedCustomer,
          balls_drilled: R.update(
            ballIndex,
            action.payload.ball
          )(state.selectedCustomer.balls_drilled),
        },
      };
    },
    // end testing dropdown
  },
  INITIAL_STATE
);
